import { render, staticRenderFns } from "./selectInpatient.vue?vue&type=template&id=2ff46faa&scoped=true"
import script from "./selectInpatient.vue?vue&type=script&lang=js"
export * from "./selectInpatient.vue?vue&type=script&lang=js"
import style0 from "./selectInpatient.vue?vue&type=style&index=0&id=2ff46faa&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff46faa",
  null
  
)

export default component.exports